import shopTrade from './data_analyse'
import payRecord from './pay_record'
import payCount from './pay_count'
export default {
	shopTrade,
	payRecord,
	payCount
}



// WEBPACK FOOTER //
// ./src/store/mp/pay_manage/index.js